import { render, staticRenderFns } from "./ViewAcademyMessage.vue?vue&type=template&id=ec5fe438&scoped=true"
import script from "./ViewAcademyMessage.vue?vue&type=script&lang=js"
export * from "./ViewAcademyMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec5fe438",
  null
  
)

export default component.exports